<template>
  <a-card
    :bodyStyle="{ padding: '10px' }"
    class="treatment-card"
    size="small"
    :bordered="true"
  >
    <template #title>{{ treatment.treatment_groups_name }}</template>
    <a-space direction="vertical" size="small" style="width: 100%">
      <a-row>
        <a-col :span="12">
          <a-space>
            <a-typography-text><eye-outlined /> 조회수 {{ treatment.view_count }}</a-typography-text>
          </a-space>
        </a-col>
        <a-col :span="12">
          <a-space>
            <a-typography-text><check-outlined /> 신청수 {{ treatment.submit_count || 0 }}</a-typography-text>
          </a-space>
        </a-col>
      </a-row>
      <a-tag color="blue">가격: {{ formatPrice(treatment.min_normal_price, treatment.max_normal_price) }}</a-tag>
      <a-tag v-if="hasEventPrice" color="green">
        행사가: {{ formatPrice(treatment.min_event_price, treatment.max_event_price) }}
      </a-tag>
    </a-space>
  </a-card>
</template>

<script>
import { EyeOutlined, CheckOutlined } from '@ant-design/icons-vue';

export default {
  name: 'TreatmentCard',
  components: {
    EyeOutlined,
    CheckOutlined
  },
  props: {
    treatment: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasEventPrice() {
      return this.treatment.min_event_price !== null && this.treatment.min_event_price !== undefined;
    }
  },
  methods: {
    formatPrice(min, max) {
      if (min === max || max === undefined) {
        return this.addCommas(min) + '원';
      }
      return `${this.addCommas(min)}~${this.addCommas(max)}원`;
    },
    addCommas(num) {
      if (num === null || num === undefined) return '';
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
}
</script>

<style scoped>
/* 추가 스타일링은 필요한 경우에만 사용 */
.treatment-card {
  margin-bottom: 10px;
}

/* antd 컴포넌트의 스타일을 오버라이드할 경우 사용 */
:deep(.ant-card-head) {
  min-height: auto;
  padding: 0 10px;
}

:deep(.ant-card-head-title) {
  padding: 8px 0;
  font-size: 13px;
  font-weight: 500;
}

:deep(.ant-tag) {
  margin-right: 0;
  margin-bottom: 4px;
}
</style> 